/** Motif de refus, ou `null` si le changement est autorisé. */
export function motifRefusCompte(opts: {
  actorId: string;
  targetId: string;
  targetRole: string;
  targetActive: boolean;
  nextRole?: string;
  nextActive?: boolean;
  activeAdminCount: number;
}): string | null {
  const nextActive = opts.nextActive ?? opts.targetActive;
  const nextRole = opts.nextRole ?? opts.targetRole;
  const etaitAdmin = opts.targetRole === 'admin' || opts.targetRole === 'super_admin';
  const resteAdmin = nextRole === 'admin' || nextRole === 'super_admin';

  if (opts.actorId === opts.targetId && nextActive === false) {
    return 'Vous ne pouvez pas désactiver votre propre compte';
  }
  if (etaitAdmin && (!nextActive || !resteAdmin) && opts.activeAdminCount <= 1) {
    return 'Impossible de retirer le dernier administrateur actif';
  }
  return null;
}

export function compterAdminsActifs(
  users: ReadonlyArray<{ id: string; role: string; actif: boolean }>,
): number {
  return users.filter((u) => u.actif && (u.role === 'admin' || u.role === 'super_admin')).length;
}
